<template>
  <div style="background: #F3F3F3">
    <div class="banner">
      <div class="titleSub">Collaboration Cases</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp" id="type">
        合作案例
      </div>
    </div>
    <div class="type">
      <div
        v-for="item in tabList"
        :key="item.name"
        @click="changeActiveType(item.label)"
        :class="[
          'item',
          'wow',
          'animate__animated',
          'animate__fadeInUp',
          'cus-pointer',
          activeType === item.label ? 'item-active' : '',
          item.type===3?'disabled-cursor':''
        ]"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="detail-type" v-if="showDetail===true">
      <div
        v-for="item in detailTypeList"
        :key="item"
        @click="changeDetailActiveType(item)"
        :class="[
          'cus-pointer',
            'wow',
          'animate__animated',
          'animate__fadeInUp',
          detailActiveType === item
            ? 'detail-type-active'
            : 'detail-type-unchecked'
        ]"
      >
        {{ item }}
      </div>
    </div>
    <div class="partner-case">
      <div
        @click="handleDetail(item.id,item.jump)"
        :class="['partner-case-item',item.jump?'cus-pointer':'disabled-cursor']"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="top">
          <img
            v-if="item.imageSrc"
            :src="require(`@/assets/${item.imageSrc}`)"
            alt=""
          />
        </div>
        <div class="desc">
          <div class="title">{{ item.name }}</div>
          <div class="introduce">{{ item.desc }}</div>
          <div class="tag">
            <div v-for="t in item.tags" class="item-uncheck">{{t}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="paging">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size.sync="pageSize"
        :current-page.sync="currentPage"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import casesData from "./casesData";
import { backItem } from "../../util/util";
export default {
  metaInfo() {
    return {
      title: '高中智慧校园管理系统_学校智慧校园数字化系统_柠檬网联', // 动态标题
      meta: [
        { name: 'description', content: '柠檬网联是中国数智园区、无线网络解决方案提供商及运营服务商。历经10年发展，已经设计研发了学校智慧校园、智慧校园服务方案、智慧校园软件系统、无线网络相关一系列的软件、硬件和平台，融合物联网、大数据、云计算、人工智能等新一代信息技术，形成了以网络为基础，以数智校园、数智厂园为应用的“一体两翼”的发展格局，以网络化、数字化、智能化持续助力学校和企业园区的数字化转型升级。'}, // 动态描述
        { name: 'keywords', content: '高中智慧校园管理系统,学校智慧校园数字化系统' } // 动态关键词
      ]
    };
  },
  name: "index",
  data() {
    return {
      tabList: [
        {
          type: 1,
          label: "无线网络"
        },
        {
          type: 2,
          label: "智慧校园"
        },
        {
          type: 3,
          label: "智慧园区"
        }
      ],
      activeType: "无线网络",
      detailTypeList: ["高校", "中职", "工厂"],
      detailActiveType: "高校",
      pageSize: 6,
      currentPage: 1,
      total: 0,
      dataList: [],
      showDetail:true,
    };
  },
  computed: {
    updateList() {
      return {
        currentPage: this.currentPage,
        activeType: this.activeType,
        detailActiveType:this.detailActiveType
      };
    }
  },
  watch: {
    $route(to) {
      const { query = {} } = to || {},
        { type = "" } = query;
      this.handleTabInit(type);
    },
    updateList() {
      this.getList();
      //backItem("type");
    },
  },
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true ,//异步加载的内容是否有效
    });
    wow.init();
  },
  created() {
    this.handleTabInit(this.$route.query.type);

    let type = this.$route.query.type;
    if (null != type) {
      this.detailActiveType = "高校";
    }
    this.getList();
  },
  methods: {
    handleDetail(id,jump) {
      if(jump){
        this.$router.push({
          name: "partnerDetail",
          query: {
            id: id
          }
        });
      }
    },
    handleTabInit(type) {
      const typeMap = {
        1: "无线网络",
        2: "智慧校园",
        3: "智慧园区"
      };
      if (typeMap[type]) {
        this.activeType = typeMap[type];
      }
    },
    changeActiveType(typeLabel) {
      if(typeLabel=='智慧园区'){
        return;
      }
      if(typeLabel=='智慧校园'){
        this.detailActiveType='高校';
        this.showDetail=false;
      }else {
        this.showDetail=true;
      }
      if (this.activeType != typeLabel) {
        const type = this.tabList.filter(v => v.label == typeLabel)[0].type;
        this.$router.replace("/partner?type=" + type);
      }
      this.activeType = typeLabel;
      this.total = 0;
      this.currentPage = 1;
       //this.getList();
    },
    changeDetailActiveType: function(type) {
      console.log("type=="+type)
      this.detailActiveType = type;
      this.total = 0;
      this.currentPage = 1;
      // this.getList();
    },
    handleCurrentChange: function(page) {
      this.currentPage = page;
      // this.getList();
    },
    getList() {
      if(this.activeType=='智慧校园'){
        this.showDetail=false;
      }else {
        this.showDetail=true;
      }
      let datas = [...casesData];

      datas = casesData.filter(
        v => this.activeType == v.type && this.detailActiveType == v.detailType
      );
      console.log(datas)
      const datasCopy = [...datas];
      this.dataList = datasCopy.splice(
        (this.currentPage - 1) * this.pageSize,
        this.pageSize
      );

      this.total = datas.length;
    }
  }
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url("../../assets/image/partner/bannerBg.png") center no-repeat;
  background-size: cover;

  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
    margin-top: 2.75rem;
    margin-left: 2.18rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    content: "Collaboration Cases";
    position: absolute;
    margin-top: 2.44rem;
    margin-left: 2.18rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0px 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }
}

.type {
  background: #f3f3f3;
  display: flex;
  justify-content: center;
  box-shadow: 0 0.03rem 0.06rem 0.01rem rgba(0, 0, 0, 0.16);

  .item {
    padding: 0.36rem 0.99rem;
    font-weight: 400;
    font-size: 0.2rem;
    color: #202124;
    border-right: 0.01rem solid #e7dfdf;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease-in-out;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100% + 0.14rem);
      background: url("../../assets/image/partner/typeBg.png") center no-repeat;
      background-size: cover;
      z-index: -1;
      opacity: 0;
    }
  }

  .item:last-child {
    border: none;
  }

  .item-active::after {
    opacity: 1;
  }
}

.partner-case {
  margin-top: 0.4rem;
  padding: 0 2.18rem 0.4rem 2.18rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .partner-case-item {
    margin-bottom: 0.4rem;
    width: calc((100% - 0.9rem) / 3);
    margin-right: 0.4rem;
    transition: all 0.3s ease-in-out;

    &:nth-child(3n) {
      margin-right: 0;
    }

    .top {
      //width: 4.68rem;
      //height: 2.68rem;
      overflow: hidden;
      img {
        //width: 100%;
        width: 4.68rem;
        height: 2.68rem;
        vertical-align: bottom;
        transition: all 0.3s ease-in-out;
      }
    }
    .desc {
      padding: 0.4rem 0.28rem 0.45rem 0.2rem;
      background-color: #ffffff;
      .title {
        font-weight: 500;
        font-size: 0.18rem;
        color: #333333;
      }
      .introduce {
        font-weight: 400;
        font-size: 0.14rem;
        color: #666666;
        line-height: 0.3rem;
        margin-top: 0.2rem;
        width: 100%;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2; /* 设置最大显示行数 */
        -webkit-box-orient: vertical;
      }
      .tag {
        margin-top: 0.2rem;
        display: flex;
        .item-uncheck {
          background-color: rgba(#fef100, 0.5);
          padding: 0.05rem 0.2rem;
          font-weight: 400;
          font-size: 0.12rem;
          color: #333333;
          margin-right: 0.2rem;
        }
      }
    }

    &:hover {
      .top {
        img {
          transform: scale(1.15);
        }
      }
      .desc {
        background-color: #fef100;
        .item-uncheck {
          background-color: #fff;
        }
      }
    }
  }
}

.detail-type {
  margin-top: 0.88rem;
  padding: 0 2.18rem 0 2.18rem;
  display: flex;

  .detail-type-active {
    background: url("../../assets/image/partner/detail-type-checked.png") center
      no-repeat;
  }

  .detail-type-unchecked {
    background: url("../../assets/image/partner/detail-type.png") center
      no-repeat;
  }

  .detail-type-active,
  .detail-type-unchecked {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.4rem;
    font-weight: 400;
    font-size: 0.2rem;
    color: #202124;
    width: 1.4rem;
    height: 0.42rem;
    background-size: 100% 100%;
  }
}
</style>

<style scoped>
.paging {
  .el-pagination {
    padding: 0;
    color: #333 !important;
    display: flex;
    justify-content: center;
    background: #fef100;
  }
  .el-pagination button {
    margin: 0 !important;
    height: 0.8rem !important;
    line-height: 0.8rem !important;
    min-width: 0.8rem !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #fdfce3 !important;
    color: #333;
  }
  .el-pager li {
    margin: 0 !important;
    padding: 0 !important;
    background: transparent !important;
    font-size: 0.16rem;
    height: 0.8rem !important;
    line-height: 0.8rem !important;
    width: 0.72rem;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    background-color: transparent;
    color: #333 !important;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: rgba(253, 252, 227, 0.8) !important;
    }
  }
  .el-pagination .btn-next .el-icon,
  .el-pagination .btn-prev .el-icon {
    font-size: 0.14rem;
    color: #333;
    font-weight: 400;
  }
  .el-icon-arrow-left:before {
    content: "上一页";
  }
  .el-icon-arrow-right:before {
    content: "下一页";
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/partner/index.vue